<script setup>
import {ref, watch} from "vue";

const props = defineProps(['needId', 'startupId', 'initRating']);

const rating = ref(0);
const editMode = ref(false);

watch(() => props.initRating, value =>{
    rating.value = value;
})
</script>

<template>
    <div
        v-if="!editMode"
        class="rating-section mb-2"
    >
        <div class="rating">
            <span v-for="index in [1,2,3,4,5]" :key="index" :class="{'rating__current': rating >= index}" @click="editMode = true"></span>
        </div>

        <a
            v-if="!rating"
            @click="editMode = true"
        >
            Click to add rating
        </a>
    </div>

    <div v-else>
    </div>
</template>

<style scoped>

</style>
